import { useEscapeToClose } from '../../hooks/useEscapeToClose';

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  // Optional leading glyph rendered in the header before the title block (source logo /
  // shield / avatar). Matches the mock's `.dh` icon slot; omitted by callers that don't need one.
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export function Drawer({ open, onClose, title, subtitle, icon, children }: DrawerProps) {
  // Only while OPEN, and only if this drawer is the topmost overlay. Sources stacks drawers on
  // purpose (Devices under the setup guide, Manage under the Pause/Disconnect confirm) so Done and
  // Cancel return to the panel behind; a per-instance listener closed the whole stack on one Esc.
  useEscapeToClose(onClose, open);

  return (
    <>
      <div className={`scrim${open ? ' open' : ''}`} onClick={onClose} />
      <aside className={`drawer${open ? ' open' : ''}`} role="dialog" aria-hidden={!open}>
        <div className="dh">
          {icon}
          <div>
            <div className="dtitle">{title}</div>
            {subtitle && <div className="dsub">{subtitle}</div>}
          </div>
          <button className="dx" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="db">{children}</div>
      </aside>
    </>
  );
}
